<footer class="footer">
  <div class="row mt-1 ms-1">
    <div class="col-auto">
      <a href="https://enin.ai">Enin AS</a>&nbsp;&nbsp;&copy; {{ this.year }}

      &nbsp;<nk-feedback-button andClass="btn btn-xs btn-secondary normal-case m-1"></nk-feedback-button>
      <span *ngIf="applicationVersion$ | async as applicationVersion">v{{ applicationVersion }}</span>
    </div>
    <div class="col-auto ms-auto">
      <div *ngIf="mergedMessageString$ | async as mergedMessageString">
        <i class="fa fa-spinner fa-spin"></i> {{ mergedMessageString }}
      </div>
    </div>
  </div>
</footer>
